import { render, staticRenderFns } from "./OptionHealthInstructions.vue?vue&type=template&id=197847e6"
import script from "./OptionHealthInstructions.vue?vue&type=script&lang=js"
export * from "./OptionHealthInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports